import AdminFacturasDetail from "./AdminFacturasDetail.container";
import container from "./container";

export default container(AdminFacturasDetail);
